import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseDataService } from 'src/app/core/services/base-data.service';
import { sharedConfig } from '../shared.config';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { globalVariables } from 'src/app/core/constants/globalVariables';
import { hrConfig } from 'src/app/features/hr/hr.config';


const API_URL = sharedConfig.url.apiUrl + 'core/data-load';
const DWN_URL = sharedConfig.url.apiUrl + 'core/data-load/download';
const DWN_XLS_URL = sharedConfig.url.apiUrl + 'core/file/remote';
const GEN_XLS_RPT = sharedConfig.url.apiUrl + 'core/xls-report/generate';
const SERVER_PATH = hrConfig.url.apiUrl;

@Injectable({
  providedIn: 'root'
})

export class DataLoadService {
  constructor(private http: HttpClient, private apiService: BaseDataService) { }

  load(functionName: string, params?: any, type?: boolean) {    
    return this.loadData(functionName, params, type ? 'map' : null);
  }

  loadJobNoticeDtl(functionName: string, params?: any, type?: boolean) {
    return this.loadJobNoticeData(functionName, params, type ? 'map' : null);
  }

  private loadJobNoticeData(path: string, params?: any, type?: string) {
    return this.apiService.save<any>(SERVER_PATH + 'hr1278/' + path + (type ? ('/' + type) : ''), params ? params : JSON.parse('{}'));
  }

  private loadData(functionName: string, params?: any, type?: string) {
    return this.apiService.save<any>(API_URL + '/' + functionName + (type ? ('/' + type) : ''), params ? params : JSON.parse('{}'));
  }

  withPackage(packageName: string, functionName: string, params?: any, type?: boolean) {
    return this.loadDataWithPackage(packageName, functionName, params, type ? 'map' : null);
  }

  private loadDataWithPackage(packageName: string, functionName: string, params?: any, type?: string) {
    return this.apiService.save<any>(API_URL + '/' + packageName + "/SKR/" + functionName + (type ? ('/' + type) : ''), params ? params : JSON.parse('{}'));
  }
  
  
  download(functionName: string, params?: any, type?: string) {

    if (type=== "XLSX" ){
      return this.apiService.download<any>(DWN_URL + '/' + functionName, params ? params : JSON.parse('{}'));
    } else{
      return this.loadData(functionName, params, type ? 'map' : null);
    }
    
  }


  public downloadPDF(dataId,pdfName): void {
    let DATA = document.getElementById(dataId);
    document.getElementById(dataId).style.padding='10px'
    let title = document.getElementById('titleName').innerHTML = pdfName;
    let companyName=document.getElementById('companyName').innerHTML=globalVariables.userInfo.company_NAME;

    html2canvas(DATA).then(canvas => {
      var imgData = canvas.toDataURL('image/png');

      var imgWidth = 210; 
      var pageHeight = 295;  
      var imgHeight = canvas.height * imgWidth / canvas.width;
      var heightLeft = imgHeight;

      var doc = new jsPDF('p', 'mm', 'a4');
      var position = 0;
      
      doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        
        doc.addPage();
        doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
      doc.save(pdfName + '.pdf');
      document.getElementById('companyName').innerHTML='';
      document.getElementById('titleName').innerHTML = '';

  
    });
  }


  /*  
  public downloadPDF(dataId,pdfName): void {
    let DATA = document.getElementById(dataId);
    let title = document.getElementById('titleName').innerHTML = pdfName;
    let companyName=document.getElementById('companyName').innerHTML=globalVariables.userInfo.company_NAME;

    html2canvas(DATA).then(canvas => {

      let fileWidth = 208;
      let fileHeight = canvas.height * fileWidth / canvas.width;

      const FILEURI = canvas.toDataURL('image/png')
      let PDF = new jsPDF('p', 'mm', 'a4');
      let position = 0;
      PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight)

      PDF.save(pdfName + '.pdf');
      document.getElementById('companyName').innerHTML='';
      document.getElementById('titleName').innerHTML = '';
      // this.showTitle=!this.showTitle;
    });
  }
  */



  genExcelReport(params?: any) {
    return this.apiService.download<any>(GEN_XLS_RPT, params ? params : JSON.parse('{}'));
  }

  downloadXlxs(url: string, type?: string) {    
    return this.apiService.xlsxDownload<any>(DWN_XLS_URL + '/' + type, url);   
  }
  
  procProcessData(params): any {   
    console.log('params',params)
    return this.apiService.save<any>(`${SERVER_PATH}hr1276/proc-appinterview-upload`, params);
  }

  procProcessFinalSelectionData(params): any {   
    console.log('params',params)
    return this.apiService.save<any>(`${SERVER_PATH}hr1280/proc-final-selection-upload`, params);
  }

  deleteCommitteeMember(params): any {
    return this.apiService.executeQuery<any>(`${SERVER_PATH}hr1186/delete-loan-approval-committee-member`, params);
  }

}
